module.exports = __webpack_public_path__ + "static/media/remember_06.14f51427.png";